var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectMarket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 116,
    viewBox: "0 0 118 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4562 46.7801C71.0762 46.7801 62.5662 46.4401 54.5962 44.2201C46.7762 42.0501 39.5962 37.8401 33.1962 32.9701C28.9962 29.8001 25.1962 27.2701 19.7462 27.6501C14.4235 27.9452 9.33664 29.9435 5.23621 33.3501C-1.69379 39.4101 -0.643785 50.6201 2.11621 58.5001C6.28621 70.3701 18.9362 78.6201 29.7062 83.9901C42.1362 90.2001 55.7862 93.7801 69.4862 95.8801C81.4862 97.7101 96.8962 99.0301 107.296 91.2001C116.856 84.0001 119.476 67.5501 117.136 56.4501C116.565 53.1698 114.815 50.2111 112.216 48.1301C105.506 43.2201 95.4962 46.5001 87.9562 46.6601C85.1562 46.7801 82.3162 46.7801 79.4562 46.7801Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9663 115.34C79.2407 115.34 95.6763 114.315 95.6763 113.05C95.6763 111.785 79.2407 110.76 58.9663 110.76C38.692 110.76 22.2563 111.785 22.2563 113.05C22.2563 114.315 38.692 115.34 58.9663 115.34Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7764 1.96C78.3176 1.96 78.7564 1.52124 78.7564 0.980001C78.7564 0.438762 78.3176 0 77.7764 0C77.2351 0 76.7964 0.438762 76.7964 0.980001C76.7964 1.52124 77.2351 1.96 77.7764 1.96Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9863 97.07C33.5276 97.07 33.9663 96.6313 33.9663 96.09C33.9663 95.5488 33.5276 95.11 32.9863 95.11C32.4451 95.11 32.0063 95.5488 32.0063 96.09C32.0063 96.6313 32.4451 97.07 32.9863 97.07Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3262 102.08V106.38",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1663 104.23H91.4763",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3862 5.66003C46.7776 5.66003 36.6034 9.87431 29.102 17.3758C21.6005 24.8772 17.3862 35.0514 17.3862 45.66C17.3862 75.02 57.3862 102.51 57.3862 102.51C57.3862 102.51 97.3862 75.44 97.3862 45.66C97.3862 35.0514 93.172 24.8772 85.6705 17.3758C78.169 9.87431 67.9949 5.66003 57.3862 5.66003ZM57.3862 60.66C54.2709 60.66 51.2255 59.7367 48.6346 58.0068C46.0438 56.2768 44.0238 53.8178 42.8298 50.9403C41.6357 48.0629 41.3213 44.8961 41.9262 41.8401C42.5311 38.784 44.0281 35.9758 46.2282 33.7702C48.4282 31.5645 51.2327 30.0604 54.2872 29.4478C57.3417 28.8351 60.5092 29.1415 63.3897 30.3282C66.2701 31.515 68.7342 33.5287 70.4708 36.1152C72.2073 38.7016 73.1383 41.7447 73.1462 44.86C73.1436 49.039 71.4823 53.0461 68.5273 56.0011C65.5723 58.9561 61.5652 60.6174 57.3862 60.62V60.66Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0662 13.07V17.37",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9062 15.22H17.2162",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectMarket);
export default __webpack_public_path__ + "static/media/SelectMarket.12b80c5ecb2448b5f6b149211cc432d3.svg";
export { ForwardRef as ReactComponent };